import React, { Component, Fragment } from 'react';
import { Layout, Typography, Select, Radio, Row, Col } from 'antd';
import { currencyText, antdSelecBoxFilterHandler } from '../utils';

const {
  DIRECTORY_THEME,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/checkout`);

const { INSTALLMENT_SELECTION: $ST } = DIRECTORY_THEME;

const { Title } = Typography;
const { Content } = Layout;
const { Option } = Select;

class InstallmentSelection extends Component {
  renderCardOptions(bankId) {
    const { cards = [] } = this.props;
    const filteredCars = cards.filter((card) => card.bank.pk === bankId);
    return filteredCars.map(({ pk, name }) => (
      <Option key={pk} value={pk}>
        {name}
      </Option>
    ));
  }

  renderCardInstallments(cardId) {
    const { cards = [], installmentId, onSetInstallmentOption } = this.props;
    const { installments = [] } = cards.find((card) => card.pk === cardId);
    const ListHeader = () => (
      <Row className='head' key='header'>
        <Col className='text-center' xs={6}>
          <span>{$ST.LIST_HEADER.COUNT}</span>
        </Col>
        <Col xs={8} />
        <Col className='text-right' xs={10}>
          <span>{$ST.LIST_HEADER.AMOUNT}</span>
        </Col>
      </Row>
    );

    return (
      <Radio.Group
        value={installmentId}
        onChange={(e) => onSetInstallmentOption(e.target.value)}
      >
        <ListHeader />
        {installments.map(
          ({ pk, installment_count, monthly_price_with_accrued_interest }) => (
            <Row
              className={`body-row ${installmentId === pk ? 'active' : ''}`}
              key={pk}
            >
              <Col className='text-left' xs={4}>
                <Radio id={`option_${pk}`} value={pk} />{' '}
              </Col>
              <Col xs={10}>
                <label className='installment-label' htmlFor={`option_${pk}`}>
                  {installment_count === 1 ? $ST.CASH_TEXT : installment_count}
                </label>
              </Col>
              <Col xs={10} className='text-right'>
                <label className='installment-label' htmlFor={`option_${pk}`}>
                  {`${monthly_price_with_accrued_interest} ${currencyText()}`}
                </label>
              </Col>
            </Row>
          )
        )}
      </Radio.Group>
    );
  }

  render() {
    const {
      banks = [],
      bankId,
      cardId,
      onSetBankOption,
      onSetCardOption,
    } = this.props;
    return (
      <div className='installment-container'>
        {!Boolean(cardId) && (
          <Fragment>
            <Title className='text-center' level={4}>
              {$ST.TITLE}:
            </Title>
            <Content>
              <Row type='flex' justify='center'>
                <Col xs={24} md={10} xl={7}>
                  <Select
                    showSearch
                    size='large'
                    value={bankId}
                    optionFilterProp='children'
                    filterOption={antdSelecBoxFilterHandler}
                    placeholder={$ST.BANK_PLACEHOLDER}
                    onChange={(bankId) =>
                      onSetBankOption && onSetBankOption(bankId)
                    }
                  >
                    {banks.map(({ pk, name }) => (
                      <Option key={pk} value={pk}>
                        {name}
                      </Option>
                    ))}
                  </Select>

                  {bankId && (
                    <Select
                      showSearch
                      size='large'
                      allowClear
                      value={cardId}
                      optionFilterProp='children'
                      placeholder={$ST.CARD_PLACEHOLDER}
                      filterOption={antdSelecBoxFilterHandler}
                      onChange={(cardId) =>
                        onSetCardOption && onSetCardOption(cardId)
                      }
                    >
                      {this.renderCardOptions(bankId)}
                    </Select>
                  )}
                </Col>
              </Row>
            </Content>
          </Fragment>
        )}

        {cardId && (
          <Row type='flex' justify='center'>
            <Col xs={24} md={12} xl={6}>
              {this.renderCardInstallments(cardId)}
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default InstallmentSelection;



// WEBPACK FOOTER //
// ./src/theme/checkout/InstallmentSelection.js